import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const brandsAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const initialState = brandsAdapter.getInitialState();

export const brandsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBrands: builder.query({
      query: () => "/brand",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // transformResponse: (responseData) => {
      //   const loadedBrand = responseData.map((brand) => {
      //     brand.id = brand._id;
      //     return brand;
      //   });
      //   return brandsAdapter.setAll(initialState, loadedBrand);
      // },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "Brand", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Brand", id })),
          ];
        } else return [{ type: "Brand", id: "LIST" }];
      },
    }),
    createBrand: builder.mutation({
      query: data => ({
        url: "/brand/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        { type: "Brand", id: "LIST" }
      ]
    }),
    updateBrand: builder.mutation({
      query: data => ({
        url: "/brand/update",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Brand", id: arg.id }
      ]
    }),
    deleteBrand: builder.mutation({
      query: ({ id }) => ({
          url: `/brand/delete`,
          method: "DELETE",
          body: { id }
      }),
      invalidatesTags: (result, error, arg) => [
          { type: "Brand", id: arg.id }
      ]
    }),
  }),
});

export const {
  useGetBrandsQuery,
  useCreateBrandMutation,
  useUpdateBrandMutation,
  useDeleteBrandMutation,
} = brandsApiSlice

// returns the query result object
export const selectBrandsResult = brandsApiSlice.endpoints.getBrands.select()

// creates memoized selector
const selectBrandsData = createSelector(
  selectBrandsResult,
  brandsResult => brandsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllBrands,
  selectById: selectBrandById,
  selectIds: selectBrandIds
  // Pass in a selector that returns the products slice of state
} = brandsAdapter.getSelectors(state => selectBrandsData(state) ?? initialState)
